import { Router } from '@lightningjs/sdk'
import { HOME } from '../../constants/routes'
import { getText } from '../../utils/dictionary'
import Button from '../button/button'
import { NAVIGATION_POINTERS_Z_INDEX } from './NavigationPointers'

export default class PointerBackButton extends Button {
  static _template() {
    return {
      ...super._template(),

      visible: false,
      mountX: 1,
      x: (w) => w,
      y: 80,
      w: 250,
      icon: 'icon-back-arrow',
      label: getText('goBackButton'),
      flexItem: false,
      zIndex: NAVIGATION_POINTERS_Z_INDEX + 2,
    }
  }

  _handleClick() {
    // Overriding the click handler so that the event doesn't reach the layout components
    const history = Router.getHistory()

    if (this.signals) {
      Object.keys(this.signals).forEach((s) => {
        this.signal(s)
      })
    } else if (history.length === 0) {
      Router.navigate(HOME)
    } else {
      Router.back()
    }

    return true
  }

  _handleHover() {
    // Overriding the hover handler so that fireAncestors doesn't reach the layout components
    this._focus()
  }
}
